export default "__VITE_ASSET__DzGABSQv__"